export const Content = ({ content, activeTab }) => {
	return <>{content[activeTab]}</>
}
